import axios from "axios";
import Cookies from 'js-cookie';
import APIURL from "./components/Constant";


const api = axios.create({
  baseURL: APIURL,
});

api.interceptors.request.use((config) => {
  const user = Cookies.get('user') || null;

  if (user) {
    const token = JSON.parse(user)?.access;
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
  }
  return config;
});


/* ===========================
   RESPONSE INTERCEPTOR (401)
=========================== */
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Clear auth cookies
      Cookies.remove("user");
      Cookies.remove("token");

      // Redirect to login
      if (typeof window !== "undefined") {
        window.location.href = "/login";
      }
    }

    return Promise.reject(error);
  }
);


export default api;


